import { CenteredSpinner, ErrorType, SpinnerProps, WrapperProps } from '.'
import { MaybeFetchState, useIsLoading } from '../hooks'

export interface StateWrapperProps<T> extends WrapperProps {
  fetchErrorType?: ErrorType
  fetchState: MaybeFetchState<T>
}

export const StateWrapper = <T,>({
  fetchErrorType = ErrorType.FETCH,
  fetchState,
  children
}: StateWrapperProps<T>) => {
  const { isLoading } = useIsLoading(fetchState, fetchErrorType)
  return <LoadingWrapper isLoading={isLoading}>{children}</LoadingWrapper>
}

export interface LoadingWrapper extends WrapperProps {
  isLoading: boolean
  spinnerProps?: SpinnerProps
}

export const LoadingWrapper = ({
  children,
  isLoading,
  spinnerProps
}: LoadingWrapper) => {
  if (isLoading) return <CenteredSpinner {...spinnerProps} />

  return <>{children}</>
}
